// @flow
import React, { useRef } from 'react';
import { Field } from 'redux-form';

type Props = {
  theme: any,
  usernameIsEmail: boolean,
  usernamePlaceholder: string,
  submit: () => void,
  submitting: bool,
  error: ?any
};

const MFAInput = ({ input, meta, nextFieldId, disabled, ...props }) => {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const value = e.target.value;
    input.onChange(value);
    
    // If a value was entered and there's a next field, focus it
    if (value && nextFieldId && value.length === 1) {
      const nextField = document.getElementById(nextFieldId);
      if (nextField) {
        nextField.focus();
      }
    }
  };

  const handleKeyDown = (e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !e.target.value) {
      const prevFieldId = `mfa${parseInt(props.id.replace('mfa', '')) - 1}`;
      const prevField = document.getElementById(prevFieldId);
      if (prevField) {
        prevField.focus();
      }
    }
  };

  return (
    <input
      {...input}
      {...props}
      ref={inputRef}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      autoComplete="off"
      maxLength={1}
      style={{ width: '45px', margin: '0 5px', textTransform: 'uppercase' }}
    />
  );
};

export default ({ theme, usernameIsEmail, usernamePlaceholder, submit, submitting, error }: Props) => {


  // overide styles from the theme config

  const styles = {

    heading: {
      color: theme.headingColor
    },

    subheading: {
      color: theme.subheadingColor
    },

    label: {
      color: theme.labelTextColor
    },

    input: {
      color: theme.inputTextColor,
      borderColor: theme.inputBorderColor
    },

    submitButton: {
      backgroundColor: theme.submitButtonColor,
      color: theme.submitButtonTextColor
    },

  }

  return (

    <div>


        <div id="login_form" className="_Portal_LoginScreen_Form_loginForm">

          <div
            className="_Portal_LoginScreen_Form_heading"
            style={styles.heading}
          >

            {'Please check your emails for a code to log in to the LeadPM.io Portal.'}

          </div>

          {error && (
            <div className="_Portal_LoginScreen_Form_invalid">
              {error}
            </div>
          )}

          <div>
            <center>

            <label
              htmlFor="mfa"
              className="_Portal_LoginScreen_Form_label"
              style={styles.label}
            >
              "One time passcode"
            </label>

                <Field
                  id="mfa1"
                  name="mfa1"
                  component={MFAInput}
                  className="_Portal_LoginScreen_Form_input _Portal_LoginScreen_Form_usernameField"
                  style={styles.input}
                  disabled={submitting}
                  nextFieldId="mfa2"
                />
                <Field
                  id="mfa2"
                  name="mfa2"
                  component={MFAInput}
                  className="_Portal_LoginScreen_Form_input _Portal_LoginScreen_Form_usernameField"
                  style={styles.input}
                  disabled={submitting}
                  nextFieldId="mfa3"
                />
                <Field
                  id="mfa3"
                  name="mfa3"
                  component={MFAInput}
                  className="_Portal_LoginScreen_Form_input _Portal_LoginScreen_Form_usernameField"
                  style={styles.input}
                  disabled={submitting}
                  nextFieldId="mfa4"
                />
                <Field
                  id="mfa4"
                  name="mfa4"
                  component={MFAInput}
                  className="_Portal_LoginScreen_Form_input _Portal_LoginScreen_Form_usernameField"
                  style={styles.input}
                  disabled={submitting}
                />
            </center>
            <br />
          </div>

          <button
            id="loginButton"
            className="_Portal_LoginScreen_Form_submitButton"
            style={styles.submitButton}
            onClick={submit}
            type="submit"
            disabled={submitting}
          >
            {submitting ? 'Authenticating' : 'Sign In'}
          </button>


        </div>
    </div>
  )

}

